import simplificada from "@/modules/Simplificada/pages/Index";
import simplificadaEditar from "@/modules/Simplificada/pages/Create";

export default [
  {
    name: "simplificada",
    path: "/simplificada",
    component: simplificada,
    meta: { title: "OS - Simplificada" },
  },
  {
    path: "/simplificada-nova",
    name: "simplificadaEditar",
    component: simplificadaEditar,
    meta: { title: "OS - Simplificada" },
  },
];
